export default __webpack_public_path__ + "static/media/F0001.f2d9822a.png";